import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { Judges } from "../../constants";
import { BACKGROUND_BEHIND, JUDGE_1 } from "../../assets";

function PresidentJudges() {
  return (
    <LandingPageLayout
      title={<>The President and Judges</>}
      currentLink="Structure of the court"
    >
      <div className="flex items-center justify-center flex-col py-8 sm:py-10 px-4 sm:px-8 lg:px-36">
        <div className="w-full sm:w-[320px] lg:w-[380px] flex flex-col relative items-center justify-center gap-y-3">
          <div className="bg-[#F5F5F5] p-3 sm:p-4 lg:p-5 rounded-lg w-full flex items-center justify-center">
            <img
              src={JUDGE_1}
              className="w-full min-h-[280px] sm:min-h-[320px] lg:min-h-[360px] object-cover h-full z-30 rounded-md"
              alt="Hon. Justice George Chibueze Nnamani"
            />
          </div>
          <img
            src={BACKGROUND_BEHIND}
            className="absolute w-full object-cover h-[200px] sm:h-[240px] lg:h-[271px] z-10 bottom-[2rem] sm:bottom-[2.5rem] lg:bottom-20"
            alt=""
          />

          <div className="flex flex-col justify-center gap-y-2 sm:gap-y-3 items-center mt-3 px-4 text-center">
            <span className="text-globalGreen text-sm sm:text-[16px] font-semibold">
              Hon. Justice George Chibueze Nnamani, FCIArb
            </span>
            <span className="text-xs sm:text-sm font-medium text-gray-regular text-center leading-relaxed">
              President, Customary Court of Appeal, Enugu State
            </span>
          </div>
        </div>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-x-10 gap-y-12 sm:gap-y-16 lg:gap-y-20 mt-12 sm:mt-16 lg:mt-20">
          {Judges.map((item, index) => (
            <div
              key={index}
              className="w-full max-h-[400px] flex flex-col relative items-center justify-center gap-y-3"
            >
              <div className="bg-[#F5F5F5] p-3 sm:p-4 lg:p-5 rounded-lg w-full flex items-center justify-center">
                <img
                  src={item.image}
                  className="w-full min-h-[200px] sm:min-h-[250px] lg:min-h-[300px] object-cover h-full z-30 rounded-md"
                  alt={`${item.name} - ${item.role}`}
                />
              </div>
              <img
                src={BACKGROUND_BEHIND}
                className="absolute w-full object-cover min-h-[150px] sm:min-h-[200px] lg:min-h-[271px] z-10 bottom-[2.5rem] sm:bottom-[3.5rem] lg:bottom-[4.5rem]"
                alt=""
              />

              <div className="flex flex-col justify-center gap-y-2 sm:gap-y-3 items-center mt-3 px-2 text-center">
                <span className="text-globalGreen text-xs sm:text-sm font-semibold">
                  {item.name}
                </span>
                <span className="text-xs sm:text-sm font-medium text-gray-regular text-center leading-relaxed">
                  {item.role}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </LandingPageLayout>
  );
}

export default PresidentJudges;
